import { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhereYouBelong() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="where-you-belong" className="relative h-screen min-h-[600px] w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560620/img/hudson_valley_drone_panorama.png)] bg-cover bg-center bg-no-repeat" />

      {}
      <div className="absolute inset-0 bg-black/20" />

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        <h1 ref={ref} className={`font-serif text-6xl font-medium tracking-tighter text-white drop-shadow-lg transition-all duration-1000 ease-out sm:text-8xl md:text-9xl lg:text-[10rem] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          Where You Belong
        </h1>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce" aria-hidden="true">
        <div className="h-24 w-0.5 rounded-full bg-white/80 shadow-sm backdrop-blur-sm" />
      </div>
    </section>;
}